/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./playable-project.vue?vue&type=template&id=4a03a88e&scoped=true&"
import script from "./playable-project.vue?vue&type=script&lang=js&"
export * from "./playable-project.vue?vue&type=script&lang=js&"
import style0 from "./playable-project.vue?vue&type=style&index=0&id=4a03a88e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a03a88e",
  null
  
)

export default component.exports